<span [title]="tooltip" [ngClass]="[labelClass, modifierClasses]"><ng-content></ng-content></span>
